export enum FinancialDataValueEnteredInEnum {
  MNE = 1,
  Entity,
}
